import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";

import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';
import { Compania } from '../Models/Compania';
import { TryCatchStmt } from '@angular/compiler';
import { Viaje } from '../Models/Viaje';
import { ViajeRecorrido } from '../Models/ViajeRecorrido';

@Injectable()
export class ViajeRecorridoService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }



  /**
   * Obtiene la posision de los camiones en tiempo real
   * @param compania Codigo de la compañia
   */
  ObtenerViajeRecorridoTiempoReal(compania: string): Observable<ViajeRecorrido[]> {

    try {

      let url = this._utiles.getURL("viajerecorrido/viajetiemporeal/" + compania);


      return this._http.get(url).map((response: Response) => {
        return <ViajeRecorrido[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


  /**
   * Obtiene el recorrido de estaria por viaje
   * @param compania Codigo de la compañia
   * @param idViaje Codigo del viaje
   */
  ObtenerViajeRecorridoEstadia(compania: string, idViaje: string): Observable<ViajeRecorrido[]> {

    try {

      let url = this._utiles.getURL("viajerecorrido/viajeestadia/" + compania + "/" + idViaje);


      return this._http.get(url).map((response: Response) => {
        return <ViajeRecorrido[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


  /**
   * Obtiene el recorrido de movimiento por viaje
   * @param compania Codigo de la compañia
   * @param idViaje Codigo del viaje
   */
  ObtenerViajeRecorridoMovimiento(compania: string, idViaje: string): Observable<ViajeRecorrido[]> {

    try {

      let url = this._utiles.getURL("viajerecorrido/viajemovimiento/" + compania + "/" + idViaje);


      return this._http.get(url).map((response: Response) => {
        return <ViajeRecorrido[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


  /**
   * Obtiene el recorrido de movimiento de los viajes que estan sincronizados
   * es utlizado en el dashboard
   * @param compania Codigo de la compañia
   */
  ObtenerViajeRecorridoMovimientoDashBoard(compania: string): Observable<ViajeRecorrido[]> {

    try {

      let url = this._utiles.getURL("viajerecorrido/viajemovimientodashboard/" + compania);


      return this._http.get(url).map((response: Response) => {
        return <ViajeRecorrido[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

  /**
   * Obtiene ek recorrido de estadia de los viajes que estan sincronizados
   * @param compania Codigo de la compañia
   */
  ObtenerViajeRecorridoEstadiaDashBoard(compania: string): Observable<ViajeRecorrido[]> {

    try {

      let url = this._utiles.getURL("viajerecorrido/viajeestadiadashboard/" + compania);


      return this._http.get(url).map((response: Response) => {
        return <ViajeRecorrido[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }



}
